module.exports = __webpack_public_path__ + "static/media/General Post Office c. 1910s (1).7e1aa60a.jpg";